import { render, staticRenderFns } from "./edit-water.vue?vue&type=template&id=f35eae34&scoped=true"
import script from "./edit-water.vue?vue&type=script&lang=js"
export * from "./edit-water.vue?vue&type=script&lang=js"
import style0 from "./edit-water.vue?vue&type=style&index=0&id=f35eae34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35eae34",
  null
  
)

export default component.exports